body = jQuery("body");

var everythingelse = document.getElementById("everythingelse");
var omni_make = document.getElementById("omni_make");

// MOBILE STUFF
var mobile_search = document.getElementById("mobile_search");
var mobile_reg_value = jQuery(".mobile_reg_value");
var colourcoderesults = jQuery(".colour_code_results");
var mobileMakes = jQuery(".make_box_results");

var mobileSearchResults = jQuery(".mobile_search_results");

var makecount = 0;
var colourcountAmount = 0;

var timeoutColoursearch;
var timeoutMakeSearch;

var translationBlock = jQuery(".translationBlock");

body.on("focusin input", "#reg_input", function(e){
    if(e.target.value === null || e.target.value === "" || e.target.value === undefined || typeof(e.target.value) === e.target.value){
        jQuery("#reg_input").attr("placeholder", "");
    }
});

body.on("focusout", "#reg_input", function(e){
    if(e.target.value !== null || e.target.value !== "" || e.target.value !== undefined || typeof(e.target.value) !== e.target.value){
        jQuery("#reg_input").attr("placeholder", translationBlock.attr("data-attr-registration"));
    }
});

body.on("focusout", "#mobile_search", function(e){
    setTimeout(function(){
        mobileSearchResults.css("display", "none");
    }, 400);
})

body.on("focusin", "#mobile_search", function(e){
    if(typeof(searchvalue) !== 'undefined'){
        mobileSearchResults.css("display", "block");
    }
})

body.on("input", "#mobile_search", function(e){

    console.log(e);

    searchvalue = e.target.value;

    mobileSearchResults.css("display", "block");

    // MOBILE REG AREA
    mobile_reg_value.children("span").text(searchvalue);
    jQuery("#reg_input").val(searchvalue);

    clearTimeout(timeoutColoursearch);
    clearTimeout(timeoutMakeSearch);

    searchValueLength = searchvalue.length;

    timeoutMakeSearch = setTimeout(function(){

        mobileMakes.html("");
        makecount = 0;

        makeArray.forEach(function(make){
            if(make.toLowerCase().includes(searchvalue.toLowerCase())){
                // WHAT WE'RE SEARCHING FOR EXISTS IN THIS LIST SO WE GRAB IT OUT
                // WE'RE GOING TO TRIM WHAT WE'RE SEARCHING FOR
                // GET INDEX OF WHAT WE'RE SEARCHING FOR

                makeIndex = make.toLowerCase().indexOf(searchvalue.toLowerCase());
                console.log(makeIndex);
                console.log(searchValueLength);
                if(makeIndex === 0){
                    newString = make.slice(makeIndex+searchValueLength);
                    console.log(newString);
                    mobileMakes.append("<div class='mobileMakeSelect'><span>"+searchvalue+"</span>"+newString+"<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><path fill='none' stroke='#BFBFBF' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.931' d='M4.44051162,8.832 C5.61919308,8.82242535 6.75075585,8.37051577 7.60872014,7.56672 L12,12 L7.60872014,7.56672 C8.39714949,6.70102382 8.84840362,5.58354214 8.88102325,4.416 C8.88102325,1.97711054 6.89293848,0 4.44051162,0 C1.98808477,0 0,1.97711054 0,4.416 C0,6.85488946 1.98808477,8.832 4.44051162,8.832 Z' transform='translate(1 1)'/></svg></div>");
                }
                if(makeIndex >= 1){
                    firstNewString = make.slice(0, makeIndex);
                    lastNewString = make.slice(makeIndex+searchValueLength);
                    console.log(makeIndex+searchValueLength);
                    console.log(firstNewString);
                    console.log(lastNewString);
                    mobileMakes.append("<div class='mobileMakeSelect'>"+firstNewString+"<span>"+searchvalue+"</span>"+lastNewString+"<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><path fill='none' stroke='#BFBFBF' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.931' d='M4.44051162,8.832 C5.61919308,8.82242535 6.75075585,8.37051577 7.60872014,7.56672 L12,12 L7.60872014,7.56672 C8.39714949,6.70102382 8.84840362,5.58354214 8.88102325,4.416 C8.88102325,1.97711054 6.89293848,0 4.44051162,0 C1.98808477,0 0,1.97711054 0,4.416 C0,6.85488946 1.98808477,8.832 4.44051162,8.832 Z' transform='translate(1 1)'/></svg></div>");
                }
                makecount++;
            }
        })
        if(makecount === 0){
            mobileMakes.append("<div class='mobileMakeSelect' onclick='event.preventDefault();'>" + translationBlock.attr("data-attr-nomakes") + "</div>");
        }
    }, 1000);

    // SEARCH FOR COLOUR CODES
    // WE WAIT 2 SECONDS FROM THE LAST KEYSTROKE TO SEARCH
    timeoutColoursearch = setTimeout(function(){
        var forEachCount = 0;
        console.log("searched");
        console.log('https://us.search.chipex.com/search?search=' + e.target.value);
        $.ajax({
            method: 'get',
            dataType: 'json',
            url: 'https://us.search.chipex.com/search?search=' + e.target.value
        }).done(function(resp){
            // EMPTY OUT THE RESULTS
            colourcoderesults.html("");
            colourcountAmount = 0;
            // WE ONLY WANT TO BRING IN 5
            // WE GET ALL THE RESPONSES THEN WE MERGE THEM AND GET JUST THE FIRST 5
            // IT ISN'T A GOOD SEARCH, SEARCHING FOR "BLA" DOESN'T GUARANTEE BLACK WILL BE THE FIRST
            uniq = [...new Set(resp)];

            for (let colourCode of uniq){
                if(colourCode.oem.toLowerCase().includes(searchvalue.toLowerCase())){
                    console.log(colourCode);

                    colorCodeIndex = colourCode.oem.toLowerCase().indexOf(searchvalue.toLowerCase());
                    console.log(colorCodeIndex);
                    console.log(searchValueLength);
                    if(colorCodeIndex === 0){
                        newString = colourCode.oem.slice(colorCodeIndex+searchValueLength);
                        colourcoderesults.append("<div><a href='/pages/registration-lookup?type=search&search="+encodeURI(colourCode.oem)+"'><span>"+searchvalue+"</span>"+newString+"<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><path fill='none' stroke='#BFBFBF' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.931' d='M4.44051162,8.832 C5.61919308,8.82242535 6.75075585,8.37051577 7.60872014,7.56672 L12,12 L7.60872014,7.56672 C8.39714949,6.70102382 8.84840362,5.58354214 8.88102325,4.416 C8.88102325,1.97711054 6.89293848,0 4.44051162,0 C1.98808477,0 0,1.97711054 0,4.416 C0,6.85488946 1.98808477,8.832 4.44051162,8.832 Z' transform='translate(1 1)'/></svg></a></div>")
                    }
                    if(colorCodeIndex >= 1){
                        firstNewString = colourCode.oem.slice(0, colorCodeIndex);
                        lastNewString = colourCode.oem.slice(colorCodeIndex+searchValueLength);
                        console.log(colorCodeIndex+searchValueLength);
                        console.log(firstNewString);
                        console.log(lastNewString);
                        colourcoderesults.append("<div><a href='/pages/registration-lookup?type=search&search="+encodeURI(colourCode.oem)+"'>"+firstNewString+"<span>"+searchvalue+"</span>"+lastNewString+"<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><path fill='none' stroke='#BFBFBF' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.931' d='M4.44051162,8.832 C5.61919308,8.82242535 6.75075585,8.37051577 7.60872014,7.56672 L12,12 L7.60872014,7.56672 C8.39714949,6.70102382 8.84840362,5.58354214 8.88102325,4.416 C8.88102325,1.97711054 6.89293848,0 4.44051162,0 C1.98808477,0 0,1.97711054 0,4.416 C0,6.85488946 1.98808477,8.832 4.44051162,8.832 Z' transform='translate(1 1)'/></svg></a></div>");
                    }

                    forEachCount++;
                    if(forEachCount === 5){
                        return;
                    }
                    colourcountAmount++;
                }
            }
            if(colourcountAmount === 0){
                colourcoderesults.append("<div onclick='event.preventDefault();'><a href=''>" + translationBlock.attr("data-attr-nocolours") + "</a></div>");
            }
        })
    }, 2000)
})

body.on("click touch", ".mobileMakeSelect", function(e){
    $('#search-ribbon-make').val(e.target.textContent.toUpperCase()).trigger("change");
    makeChange();
})

body.on("click touch", "#mmy-back-button", function(){
    jQuery("body").removeClass("showMakeYear");
    jQuery("#search-ribbon-make").val(null).trigger("change");
});



$.ajax({
    method: 'get',
    dataType: 'json',
    url: 'https://us.search.chipex.com/make'
}).done(function(resp){

    // ADD THESE TO THE MOBILE MAKES
    makeArray = resp;

    $(".select_wrap.year").addClass("disabled").attr("onclick", "event.preventDefault(); if(jQuery('.select_wrap.model').hasClass('disabled')){$('#search-ribbon-make').select2('open');}else{$('#search-ribbon-model').select2('open');}");
    makeList = resp.filter(name => !popBrands.includes(name))

    for(var i = 0; i < makeList.length; i++){
        opt = document.createElement('option');
        opt.innerHTML = makeList[i];
        opt.value = makeList[i];
        everythingelse.append(opt);
    }
});

function makeChange(){

    body.addClass("showingModelYear");

    jQuery("#mobile_search").val(jQuery("#search-ribbon-make").val())

    var modelOptiongroup = $("#search-ribbon-model #model");
    modelOptiongroup.html("");

    $(".select_wrap.model").removeClass("disabled").attr("onclick", "");

    $.ajax({
        method: 'get',
        dataType: 'json',
        url: 'https://us.search.chipex.com/model?make=' + jQuery("#search-ribbon-make").val()
    }).done(function(resp){
        for(var i = 0; i < resp.length; i++){
            opt = document.createElement('option');
            opt.innerHTML = resp[i];
            opt.value = resp[i];
            modelOptiongroup.append(opt);
        }
        $('#search-ribbon-model').select2({
            placeholder: translationBlock.attr("data-attr-model")
        });
        $("#search-ribbon-model").val(null).trigger("change");
        $("#search-ribbon-year").val(null).trigger("change");
    })

}

$(document).ready(function() {

    $('#search-ribbon-make').select2({
        placeholder: translationBlock.attr("data-attr-make")
    });
    $('#search-ribbon-make').on('select2:select', function (e) {
        jQuery("body").addClass("showMakeYear");
    });
    $('#search-ribbon-make').on('select2:select', function (e) {
        makeChange();
    });


    $('#search-ribbon-model').select2({
        placeholder: translationBlock.attr("data-attr-model")
    });
    $('#search-ribbon-model').on('select2:select', function (e) {
        var make = jQuery("#search-ribbon-make option:selected").text();
        var yearOptiongroup = $("#search-ribbon-year #year");
        yearOptiongroup.html("");
        $(".select_wrap.year").removeClass("disabled").attr("onclick", "");

        $.ajax({
            method: 'get',
            dataType: 'json',
            url: 'https://us.search.chipex.com/year?make=' + make + '&model=' + e.params.data.text
        }).done(function(resp){
            years = [];

            for(var i = 0; i < resp.length; i++){
                opt = document.createElement('option');
                opt.innerHTML = resp[i];
                opt.value = resp[i];
                yearOptiongroup.append(opt);
            }
            $('#search-ribbon-year').select2({
                placeholder: translationBlock.attr("data-attr-year")
            });
            $("#search-ribbon-year").val(null).trigger("change");
        })

    });


    $('#search-ribbon-year').select2({
        placeholder: translationBlock.attr("data-attr-year")
    });
});

body.on("click touch", ".reg_submit", function(){

    reginput = jQuery('#reg_input');

    // CHECK IF REG IS EMPTY
    if(
        reginput.val() === '' || reginput.val() === null){
        reginput.focus();
        return;
    }

    // IF IT'S NOT WE NEED TO DECIDE WHAT PAGE WE'RE GOING TO
    $.get('https://app.chipex.co.uk/api/lookup-reg/' + reginput.val())
        .done(function(resp){
            resp.type = 'reg-lookup';
            var query = makeQuery(resp);
            var redirect = '/pages/registration-lookup/' + resp.Manufacturer + '?' + query;
            window.location = redirect;
        })
        .fail(function(err){
            //show err
            if(err.status == 404){
                window.location = "/pages/find-your-colour/" + reginput.val();
                return stop_loading($wrapper, 'Not Found');
            }
        })
});

body.on("click touch", ".floating-reg_submit", function(){

    floatingreginput = jQuery('#floating-reg_input');

    // CHECK IF REG IS EMPTY
    if(
        floatingreginput.val() === '' || floatingreginput.val() === null){
        floatingreginput.focus();
        return;
    }

    // IF IT'S NOT WE NEED TO DECIDE WHAT PAGE WE'RE GOING TO
    $.get('https://app.chipex.co.uk/api/lookup-reg/' + floatingreginput.val())
        .done(function(resp){
            resp.type = 'reg-lookup';
            var query = makeQuery(resp);
            var redirect = '/pages/registration-lookup/' + resp.Manufacturer + '?' + query;
            window.location = redirect;
        })
        .fail(function(err){
            //show err
            if(err.status == 404){
                window.location = "/pages/find-your-colour/" + floatingreginput.val();
                return stop_loading($wrapper, 'Not Found');
            }
        })
});
body.on("click touch", "#mmy-button", function(){
    if(jQuery(".select_wrap").hasClass("disabled") || jQuery(".select_wrap.year select").val() === "" || jQuery(".select_wrap.year select").val() == null ){
        // WE'VE STILL GOT DROP DOWNS NOT FILLED OUT

        // YEAR GETS DISABLED TAKEN OFF IT WHEN A MODEL IS CHOSEN SO WE NEED TO CHECK THE VALUE
        if(jQuery(".select_wrap.year").val() !== ""){
            $('#search-ribbon-year').select2('open');
        }else{
            // GET THE FIRST NON DISABLED SELECT AND GET IT'S ID
            var firstDisabled = jQuery(".select_wrap:not(.disabled)").last().children("select").attr("id");
            $('#'+firstDisabled).select2('open');
        }
        return;
    }else{
        // NONE ARE DISABLED SO WE COMBINE THE VALUES AND SEND IT TO URL
        window.location = '/pages/registration-lookup/'+encodeURIComponent(jQuery("#search-ribbon-make").val())+'?type=mmy&Manufacturer='+encodeURIComponent(jQuery("#search-ribbon-make").val())+'&Model='+encodeURIComponent(jQuery("#search-ribbon-model").val())+'&Year='+encodeURIComponent(jQuery("#search-ribbon-year").val());
    }
});

let search_ribbon = jQuery(".search_ribbon");

// WHEN IT'S FOCUSED WE NEED TO PULL FOCUS TO THE OTHER ELEMENTS
body.on('focus', '#reg_input',function(e) {
    search_ribbon.attr("class", "search_ribbon");
    search_ribbon.addClass("reg-focus");
});

// WHEN WE UNFOCUS WE NEED TO CHECK IT HASN'T STARTED TO BE FILLED OUT
body.on('focusout', '#reg_input',function(e) {
    if(jQuery("#reg_input").val() === ""){
        search_ribbon.removeClass("reg-focus");
    }
});

body.on('focus', '#colourcode_input',function(e) {
    search_ribbon.attr("class", "search_ribbon");
    search_ribbon.addClass("colourcode-focus");
});

// WHEN WE UNFOCUS WE NEED TO CHECK IT HASN'T STARTED TO BE FILLED OUT
body.on('focusout', '#colourcode_input',function(e) {
    if(jQuery("#reg_input").val() === ""){
        search_ribbon.removeClass("colourcode-focus");
    }
});

body.on('keypress', '#reg_input',function(e) {
    if(e.which == 13) {
        jQuery(".reg_submit").click();
    }
});

body.on('keypress', '#floating-reg_input',function(e) {
    if(e.which == 13) {
        jQuery(".floating-reg_submit").click();
    }
});

body.on('keypress', '#colourcode_input',function(e) {
    if(e.which == 13) {
        jQuery(this).next("button").click();
    }
});
